var map = {
	"./decidim/avatar-multiuser.png": 60092,
	"./decidim/brands/facebook.svg": 87442,
	"./decidim/brands/google.svg": 6003,
	"./decidim/brands/twitter-x.svg": 50224,
	"./decidim/cc-badge.png": 92814,
	"./decidim/decidim-logo.svg": 96446,
	"./decidim/default-avatar.svg": 72682,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 478,
	"./decidim/icons.svg": 99517,
	"./decidim/pattern.png": 11706,
	"./decidim/placeholder-card-g.svg": 39511,
	"./decidim/placeholder-card-l.svg": 67244,
	"./decidim/placeholder.jpg": 73139,
	"./decidim/remixicon.symbol.svg": 46107,
	"./decidim/vendor/social-share-button/douban.svg": 41482,
	"./decidim/vendor/social-share-button/email.svg": 84551,
	"./decidim/vendor/social-share-button/facebook.svg": 86809,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 71131,
	"./decidim/vendor/social-share-button/hacker_news.svg": 53963,
	"./decidim/vendor/social-share-button/linkedin.svg": 26039,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 75184,
	"./decidim/vendor/social-share-button/pinterest.svg": 46889,
	"./decidim/vendor/social-share-button/reddit.svg": 78201,
	"./decidim/vendor/social-share-button/telegram.svg": 71072,
	"./decidim/vendor/social-share-button/tumblr.svg": 30103,
	"./decidim/vendor/social-share-button/twitter.svg": 23286,
	"./decidim/vendor/social-share-button/vkontakte.svg": 91048,
	"./decidim/vendor/social-share-button/wechat.svg": 19827,
	"./decidim/vendor/social-share-button/whatsapp.svg": 7755,
	"./decidim/vendor/social-share-button/x.svg": 13567,
	"./decidim/vendor/social-share-button/xing.svg": 62617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10883;